export const potencyCodeMap = {
    C48521: 'Packet',
    C48520: 'Package',
    C48481: 'Cartridge',
    C48480: 'Capsule',
    C65060: 'Puff',
    C47916: 'Kit',
    C64696: 'Caplet',
    C62276: 'Insert',
    C122629: 'Actuation',
    C48525: 'Pellet',
    C48524: 'Patch',
    C48529: 'Pint',
    C64933: 'Each',
    C48494: 'Fluid Ounce',
    C48534: 'Quart',
    C25397: 'Application',
    C48499: 'Implant',
    C186222: 'Chewable gel (Gummy)',
    C48491: 'Metric Drop',
    C48490: 'Disk',
    C67315: 'MilliUnit',
    C42915: 'Enema',
    C124231: 'Inch Strip',
    C48538: 'Strip',
    C48537: 'Spray',
    C48536: 'Scoopful',
    C49668: 'Centimeter',
    C48539: 'Suppository',
    C48540: 'Syringe',
    C48501: 'Inhalation',
    C53499: 'Film',
    C48500: 'Inch',
    C62609: 'Ring',
    C69124: 'Gum',
    C28254: 'Milliliter',
    C48542: 'Tablet',
    C28253: 'Milligram',
    C71324: 'Sachet',
    C71204: 'Nebule',
    C48580: 'Gallon',
    C62412: 'Applicator',
    C48505: 'Liter',
    C48548: 'Troche',
    C48506: 'Lozenge',
    C48475: 'Bar',
    C48552: 'Wafer',
    C53503: 'Stick',
    C48155: 'Gram',
    C48551: 'Vial',
    C53502: 'Sponge',
    C48473: 'Ampule',
    C48512: 'Milliequivalent',
    C65032: 'Pad',
    C48152: 'Microgram',
    C111984: 'Pump',
    C53504: 'Swab',
    C122632: 'Injection',
    C122631: 'Dropperful',
    C122630: 'Auto-Injector',
    C102405: 'Capful',
    C38046: 'Unspecified',
    C44278: 'Unit',
    C122635: 'Pre-Filled Pen Syringe',
    C48519: 'Ounce',
    C122634: 'Pill',
    C122633: 'Lollipop'
};

export type PotencyCode = keyof typeof potencyCodeMap;

export const copayEligiblePotencyCodes = new Set(['C48480', 'C48542']);